var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"telematicsReadingList"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],class:("loader" + _vm.loaderClass)}),_vm._v(" "),(_vm.assetwarrantiesVal != undefined)?[_c('div',{staticClass:"bg-white data-table p-0"},[_c('vue-good-table',{ref:"assetWarrantyList",attrs:{"mode":"remote","title":"Asset Warranty","totalRows":_vm.totalRecords,"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{
                    enabled: (_vm.totalRecords > _vm.serverParams.perPage ? true:false),
                    position: 'bottom',
                    perPage: _vm.perPage,
                    perPageDropdown:_vm.dropDownPerPage,
                    dropdownAllowAll: false,
                },"select-options":{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                },"search-options":{
                enabled: false,
                }},on:{"on-page-change":_vm.onPageChange,"on-selected-rows-change":_vm.selectionChanged,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange,"on-sort-change":_vm.onSortChange}})],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d9033c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/asset/AssetWarranty.vue
// module id = null
// module chunks = 